<template lang="html">
  <vs-card id="client-details-loading" class="vs-con-loading__container">
    <vs-tabs>
      <vs-tab
        :label="$tc('client') | capitalize"
        icon-pack="feather"
        icon="icon-users"
      >
        <div class="tab-text">
         <edit-client :data="client" @submit="updateClient"/>
        </div>
      </vs-tab>
      <vs-tab
        :label="$tc('facility',2) | capitalize"
        icon-pack="feather"
        icon="icon-map"
      >
        <div class="tab-text">
          <edit-facility :data="facilities" :id="clientId" @reload="getClientFacilities"/>
        </div>
      </vs-tab>
      <vs-tab
        :label="$t('headquarter') | capitalize"
        icon-pack="feather"
        icon="icon-home"
      >
        <div class="tab-text">
          <edit-headquarter :data="headquarter" @submit="updateHeadquarter"/>
        </div>
      </vs-tab>
      <vs-tab
        :label="$tc('rate',2) | capitalize"
        icon-pack="feather"
        icon="icon-trending-up"
      >
        <div class="tab-text">
          <edit-rate :data="rates" :id="clientId" @reload="getClientRates"/>
        </div>
      </vs-tab>
    </vs-tabs>
  </vs-card>
</template>

<script>
import EditClient from './components/EditClient'
import EditFacility from './components/EditFacility'
import EditHeadquarter from './components/EditHeadquarter'
import EditRate from './components/EditRate'

import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate'
import client from '@/http/requests/client';

export default {
  components: {
    EditClient,
    EditFacility,
    EditHeadquarter,
    EditRate,
  },

  computed: {
    clientId() {
      return this.$route.params.id;
    },

    isLoading(){
      return this.loading.client || this.loading.headquarter || this.loading.facility || this.loading.rate
    }
  },

  mixins: [loading, validate],

  data: () => ({
    client: {
      name: '',
      shortName: '',
      address1: '',
      address2: '',
      addressZip: '',
      addressCity: '',
      maxHours: '',
      aboveHourlyRate: '',
      scaFileName: '',
      mxnFundsTransferInfo: '',
      usdFundsTransferInfo: '',
      invoiceDay: '',
      scheduleDayInvoice: '',
      canMultireview: false,
      isDirectFundsMode: false,
      code: '',
      darwinAccount: '',
      color: '',
      isActive:false,
      entryReport:false,
      entryReportFrequeny:2
    },
    headquarter:{
      name: '',
      address1: '',
      address2: '',
      addressCity: '',
      addressZip: '',
      managerName:'',
      managerEmail:'',
      managerPhone:''
    },
    facilities:[],
    rates:[],
    loading:{
      client:false,
      headquarter:false,
      facility:false,
      rate:false
    },
  }),

  mounted() {
    this.getClientDetails()
    this.getClientHeadquarter()
    this.getClientFacilities()
    this.getClientRates()
  },

  methods: {
    getClientDetails() {
      this.loading.client = true
      client.getClientDetails(this.clientId)
        .then((res) => {
          this.client.name = res.data.data.ClientName
          this.client.shortName = res.data.data.ShortName
          this.client.address1 = res.data.data.Address1
          this.client.address2 = res.data.data.Address2
          this.client.addressZip = res.data.data.AddressZip
          this.client.addressCity = res.data.data.AddressCity
          this.client.scaFileName = res.data.data.SCAFileName
          this.client.mxnFundsTransferInfo = res.data.data.MXPFundsTransferInfo
          this.client.usdFundsTransferInfo = res.data.data.USDFundsTransferInfo
          this.client.invoiceDay = res.data.data.InvoiceDay
          this.client.canMultireview = res.data.data.can_multireview === '1' ? true : false
          this.client.isDirectFundsMode = res.data.data.IsDirectFundsMode === '1' ? true : false
          this.client.code = res.data.data.code
          this.client.darwinAccount = res.data.data.DarwinAccount
          this.client.color = res.data.data.color
          this.client.maxHours = res.data.data.MaxHours4RegularRate
          this.client.aboveHourlyRate = res.data.data.AboveHourlyRate
          this.client.scheduleDayInvoice = '1'
          this.client.isActive = res.data.data.IsActive === '1' ? true : false
          this.client.entryReport = res.data.data.entry_report === '1' ? true : false
          this.client.entryReportFrequency = res.data.data.entry_report_frequency
          if(res.data.data.extra_settings !== null){
            let extra_settings = res.data.data.extra_settings
              this.client.scheduleDayInvoice = extra_settings.schedule_day_invoice !== undefined ? extra_settings.schedule_day_invoice : '1'
          }
          this.loading.client = false
        })
        .catch((res) => {
          this.loading.client = false
        })
    },

    getClientHeadquarter(){
      this.loading.headquarter = true
      client.getClientHeadquarter(this.clientId)
        .then((res) => {
          this.headquarter.name = res.data.data.HeadquarterName
          this.headquarter.address1 = res.data.data.Address1
          this.headquarter.address2 = res.data.data.Address2
          this.headquarter.addressZip = res.data.data.AddressZip
          this.headquarter.addressCity = res.data.data.AddressCity
          this.headquarter.managerName = res.data.data.ManagerName
          this.headquarter.managerEmail = res.data.data.ManagerEmail
          this.headquarter.managerPhone = res.data.data.ManagerPhone

          this.loading.headquarter = false
        })
        .catch((res) => {
          this.loading.headquarter = false
        })
    },

    getClientFacilities(){
      this.loading.facility = true
      client.getClientFacilities(this.clientId)
        .then((res) => {
          this.facilities = [...res.data.data]
          this.loading.facility = false
        })
        .catch((res) => {
          this.loading.facility = false
        })
    },

    getClientRates(){
      this.loading.rate = true
      client.getClientRates(this.clientId)
        .then((res) => {
          this.rates = [...res.data.data]
          this.loading.rate = false
        })
        .catch((res) => {
          this.loading.rate = false
        })
    },

    updateClient(val){
      let data = {
        ClientName:val.name,
        ShortName:val.shortName,
        code:val.code,
        color:val.color,
        InvoiceDay:val.invoiceDay,
        SCAFileName:val.scaFileName,
        Address1:val.address1,
        Address2:val.address2,
        AddressCity:val.addressCity,
        AddressZip:val.addressZip,
        DarwinAccount:val.darwinAccount,
        extra_settings:{"schedule_day_invoice": val.scheduleDayInvoice},
        AboveHourlyRate:val.aboveHourlyRate,
        can_multireview:val.canMultireview,
        IsDirectFundsMode:val.isDirectFundsMode,
        MaxHours4RegularRate:val.maxHours,
        MXPFundsTransferInfo:val.mxnFundsTransferInfo,
        USDFundsTransferInfo:val.usdFundsTransferInfo,
        IsActive:val.isActive,
        entry_report:val.entryReport,
        entry_report_frequency:val.entryReportFrequency
      }
      this.loading.client = true
      client.updateClient(this.clientId,data)
      .then((res) => {
        this.$vs.notify({
          color: 'success',
          title: this.$i18n.messages[this.$i18n.locale].success,
          text: this.$i18n.messages[this.$i18n.locale].client_updated
        });
        this.loading.client = false
      })
      .catch((res) => {
        this.displayErrors(res)
        this.loading.client = false
      })
    },

    updateHeadquarter(val){
      let data = {
        Address1: val.address1,
        Address2: val.address2,
        ManagerName: val.managerName,
        ManagerEmail: val.managerEmail,
        ManagerPhone: val.managerPhone,
        AddressCity: val.addressCity,
        AddressZip: val.addressZip,
        HeadquarterName: val.name,
      }
      this.loading.headquarter = true
      client.updateHeadquarter(this.clientId, data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].headquarter_updated
          });
          this.loading.headquarter = false
        })
        .catch((res) => {
          this.displayErrors(res)
          this.loading.headquarter = false
        })
    }

  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`client-details-loading`)
      } else {
        this.closeLoading(`client-details-loading`)
      }
    },
  }
}
</script>

<style lang="css" scoped>
</style>
